// Recent searches are stored in plain localStorage (no per-user namespacing,
// since the backend has no per-customer "recent searches" concept to sync
// against). On a shared device that means one signed-in customer's search
// history would otherwise be visible to the next person who logs in (or to a
// guest) unless it's cleared on sign-out — clearRecentSearches() handles that,
// called from AuthContext on logout and on any session-expiry path.
export const RECENT_SEARCHES_KEY = 'fnh_recent_searches';
const MAX_RECENT_SEARCHES = 5;

export const readRecentSearches = () => {
  try {
    const raw = localStorage.getItem(RECENT_SEARCHES_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.slice(0, MAX_RECENT_SEARCHES) : [];
  } catch {
    return [];
  }
};

export const saveRecentSearch = (term) => {
  const trimmed = term.trim();
  if (!trimmed) return;
  const existing = readRecentSearches().filter((s) => s.toLowerCase() !== trimmed.toLowerCase());
  const next = [trimmed, ...existing].slice(0, MAX_RECENT_SEARCHES);
  localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(next));
};

export const clearRecentSearches = () => {
  localStorage.removeItem(RECENT_SEARCHES_KEY);
};
